<template>
  <v-card :class="classes">
    <v-card-text>
      <v-btn small flat icon absolute left @click="closeCard">
        <v-icon>close</v-icon>
      </v-btn>
      <p>{{ card.message }}</p>
      <v-btn v-if="card.link" flat :to="card.link.href" active-class="">
        {{ card.link.label }}
      </v-btn>
    </v-card-text>
  </v-card>
</template>

<script>
  import { mapState, mapActions } from 'vuex';

  export default {
    data() {
      return {
        closeCardTimeout: null,
        hideCard: false
      };
    },
    computed: {
      visible() {
        return !this.hideCard && this.cards.length > 0;
      },
      card() {
        if (this.cards.length === 0) {
          return {};
        } else {
          return this.cards[0];
        }
      },
      classes() {
        const classes = ['notification-card'];
        if (this.visible) {
          classes.push('notification-card-visible');
        }

        return classes;
      },
      ...mapState('alert', [
        'cards'
      ])
    },
    watch: {
      visible(val) {
        if (val) {
          this.closeCardTimeout = setTimeout(() => {
            this.closeCardTimeout = null;
            this.closeCard();
          }, 30000);
        }
      }
    },
    methods: {
      closeCard() {
        if (this.closeCardTimeout) {
          clearTimeout(this.closeCardTimeout);
          this.closeCardTimeout = null;
        }
        this.hideCard = true;
        setTimeout(() => {
          this.popCard();
          setTimeout(() => {
            this.hideCard = false;
          }, 100);
        }, 500);
      },
      ...mapActions('alert', [
        'popCard'
      ])
    }
  };
</script>

<style lang="less" scoped>
  @card-width: 350px;
  @card-height: 150px;

  .notification-card {
    position: fixed;
    right: -@card-width;
    bottom: 15px;
    transition: right 0.5s;
    width: 90%;

    @media only screen and (min-width: @card-width + 30px) {
      width: @card-width;
    }

    p {
      margin-top: 30px;
    }

    .v-card__text {
      min-height: @card-height;
    }

    &.notification-card-visible {
      right: 15px;
    }
  }
</style>
